import { takeEvery, put, call, all, fork } from "redux-saga/effects";
import { message } from "antd";
import { postAdd, getList } from "../../helpers/Helper";
import {
  initiateCall,
  callConnected,
  callFailed,
  hangupCall,
  hangupSuccess,
  submitCallFeedback,
  feedbackSuccess,
  feedbackFailed,
  checkAgentStatus,
  statusCheckSuccess,
  fetchDispositions,
  fetchDispositionsSuccess,
  fetchDispositionsFailed,
  clearBusyStatus,
} from "./audioCallSlice";

function* InitiateCallSaga({ payload }) {
  try {
    const response = yield call(postAdd, "/thirdparty/sampark/call/", {
      connect_number: payload.phoneNumber,
      purchase_id: payload.purchaseId,
      sale_id: payload.saleId,
    });
    if (response.status === 200) {
      yield put(callConnected());
    } else {
      const errorMessage = response?.data?.desc ||response?.data?.message || response.message || "Call failed";
      message.error(errorMessage);
      yield put(callFailed(errorMessage));
    }
  } catch (error) {
    console.error("Call initiation failed:", error);
    const errorMessage = error?.response?.data?.desc || error?.message || error?.error?.message ||  error?.response?.data?.message || "Failed to initiate call. Please try again.";
    message.error(errorMessage);
    yield put(callFailed(errorMessage));
  }
}

function* HangupCallSaga() {
  try {
    const response = yield call(postAdd, "/thirdparty/sampark/hangup/", {});
    if (response.status === 200) {
      yield put(hangupSuccess());
    } else {
      const errorMessage = response?.data?.desc ||response?.data?.message || "Hangup failed";
      message.error(errorMessage);
      // Still move to feedback even if hangup API fails
      yield put(hangupSuccess());
    }
  } catch (error) {
    console.error("Hangup failed:", error);
    const errorMessage = error?.response?.data?.desc || error?.message ||error?.error?.message ||  error?.response?.data?.message || "Hangup failed";
    message.error(errorMessage);
    // Still move to feedback even if hangup API fails
    yield put(hangupSuccess());
  }
}

function* SubmitFeedbackSaga({ payload }) {
  try {
    const response = yield call(postAdd, "/thirdparty/sampark/closecall/", {
      callnumber: payload.phoneNumber || "",
      disposition_1_id: payload.feedbackData.disposition_1_id,
      disposition_2_id: payload.feedbackData.disposition_2_id,
      disposition3: payload.feedbackData.disposition3 || "",
      callback_date: payload.feedbackData.callback_date || "",
      callnotes: payload.feedbackData.callnotes || "",
    });
    if (response.status === 200) {
      message.success("Feedback submitted successfully");
      yield put(feedbackSuccess());
    } else {
      const errorMessage = response?.data?.desc ||response?.data?.message || "Failed to submit feedback";
      message.error(errorMessage);
      yield put(feedbackFailed());
    }
  } catch (error) {
    console.error("Feedback submission failed:", error);
    const errorMessage = error?.response?.data?.desc || error?.message || error?.error?.message ||  error?.response?.data?.message ||"Failed to submit feedback";
    message.error(errorMessage);
    yield put(feedbackFailed());
  }
}

function* CheckAgentStatusSaga() {
  try {
    const response = yield call(getList, "/thirdparty/sampark/status/");
    if (response) {
      yield put(statusCheckSuccess(response));
      if (response.agent_name) {
        localStorage.setItem("agent_name", response.agent_name);
      }
    }
  } catch (error) {
      // Handle different error response formats
      const errorMsg = error?.response?.data?.desc || 
                       error?.response?.data?.error || 
                       error?.response?.data?.message ||
                       error?.error?.message || 
                       error?.message || 
                       "Failed to load mapping data";
      message.error(errorMsg);
    }
}

function* FetchDispositionsSaga() {
  try {
    // Fetch disposition type 1
    const response1 = yield call(getList, "/masters/mini/samparkdisposition/", {
      params: { disposition_type: 1 }
    });
    
    // Fetch disposition type 2
    const response2 = yield call(getList, "/masters/mini/samparkdisposition/", {
      params: { disposition_type: 2 }
    });

    yield put(fetchDispositionsSuccess({
      disposition1: response1?.results || [],
      disposition2: response2?.results || [],
    }));
  } catch (error) {
    console.error("Failed to fetch dispositions:", error);
    const errorMsg = error?.response?.data?.desc || 
                     error?.response?.data?.error || 
                     error?.response?.data?.message ||
                     error?.error?.message || 
                     error?.message || 
                     error.error[0] ||
                     "Failed to load disposition options";
    message.error(errorMsg);
    yield put(fetchDispositionsFailed());
  }
}

function* watchAudioCall() {
  yield takeEvery(initiateCall.type, InitiateCallSaga);
  yield takeEvery(hangupCall.type, HangupCallSaga);
  yield takeEvery(submitCallFeedback.type, SubmitFeedbackSaga);
  yield takeEvery(checkAgentStatus.type, CheckAgentStatusSaga);
  yield takeEvery(fetchDispositions.type, FetchDispositionsSaga);
}

export default function* audioCallSaga() {
  yield all([fork(watchAudioCall)]);
}
